'use client';

import {datadogRum} from '@datadog/browser-rum';
import {useEffect} from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  useEffect(() => {
    datadogRum.addError(error, {
      source: 'error-boundary',
      digest: error.digest,
    });
  }, [error]);

  return (
    <div style={{padding: '2rem', textAlign: 'center'}}>
      <h2>Something went wrong</h2>
      <p>An unexpected error has occurred. The error has been reported to the Dagster team.</p>
      <button
        onClick={reset}
        style={{
          marginTop: '1rem',
          padding: '0.5rem 1rem',
          cursor: 'pointer',
        }}
      >
        Try again
      </button>
    </div>
  );
}
